import AdminList from "@/components/Admin/AdminList/AdminList.vue";
import "./GroupsAdmin.scss";
import { getTokenHeader } from "@/helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import axios from "axios";
import { debounce } from "lodash";

const defaultItem = {
  name: "",
  description: "",
  principal_id: "",
  roles: []
};

export default {
  name: "PrincipalsAdmin",
  components: {
    AdminList
  },

  data: () => ({
    dialog: false,
    dialogDelete: false,
    isValid: false,
    defaultFilter: { searchText: "", itemsPerPage: 25 },
    filter: {},
    headers: [
      { text: "Name", value: "name" },
      { text: "Mandant", value: "principal.name" },
      { text: "Id", value: "id" },
      { text: "Aktionen", value: "actionChange", sortable: false }
    ],
    editedIndex: -1,
    editedGroup: { ...defaultItem }
  }),
  async mounted() {
    this.filter = this.defaultFilter;
    this.filter.itemsPerPage = this.defaultFilter.itemsPerPage;
    try {
      await this.applyFilter(this.filter);
      await this.$store.dispatch("getRoleCategories");
      await this.$store.dispatch("getPrincipals");
    } catch (err) {
      await this.$store.dispatch("createError", err.message);
    }
  },
  methods: {
    async applyFilter(filter) {
      if (!filter) filter = this.filter;
      if (filter.limit) delete filter.limit;
      await this.$store.dispatch("getGroups", filter);
    },
    applySearchText: debounce(async function() {
      if (this.filter.searchText.length >= 3 || !this.filter.searchText.length)
        await this.applyFilter(this.filter);
    }, 500),
    editGroup(group) {
      if (group) this.editedGroup = { ...group };
      this.dialog = true;
      //dialog fenster öffnet sich → Datensatz kann bearbeitet werden
    },
    close() {
      this.editedGroup = { ...defaultItem };
      this.uncheckRoles();
      this.$refs.editForm.reset();
      this.dialog = false;
    },
    async save(closeDialog) {
      try {
        const headers = getTokenHeader();
        let response;
        if (this.editedGroup.id)
          response = await axios.put(
            `${env.auth_api_client_url}groups/update/`,
            this.editedGroup,
            { headers }
          );
        else
          response = await axios.post(
            `${env.auth_api_client_url}groups/add/`,
            this.editedGroup,
            { headers }
          );
        if (response.status === 200 || response.status === 201) {
          if (!this.editedGroup.id) this.editedGroup = response.data.data;
          await this.$store.dispatch("getGroups");
          await this.$store.dispatch(
            "createSuccess",
            this.editedGroup.id
              ? "Gruppe wurde erfolgreich aktualisiert"
              : "Gruppe wurde erfolgreich angelegt"
          );
          if (closeDialog) this.close();
        }
      } catch (error) {
        await this.$store.dispatch("createError", error);
      }
    },
    setRole(isChecked, role) {
      const roleIdentifier = role?._id || role?.id;
      if (!roleIdentifier) return;

      if (isChecked) {
        if (!this.editedGroup.roles.includes(roleIdentifier)) {
          this.editedGroup.roles.push(roleIdentifier);
        }
      } else {
        const possibleRoleIds = [role?._id, role?.id].filter(Boolean);
        this.editedGroup.roles = this.editedGroup.roles.filter(
          savedRole => !possibleRoleIds.includes(savedRole)
        );
      }
    },
    setRolesChecked(roleCategories) {
      roleCategories.forEach(cat => {
        cat.roles.forEach(role => {
          const possibleRoleIds = [role._id, role.id].filter(Boolean);
          role.checked = possibleRoleIds.some(roleId =>
            this.editedGroup?.roles?.includes(roleId)
          );
        });
      });
    },
    uncheckRoles() {
      this.roleCategories.forEach(cat => {
        cat.roles.forEach(role => {
          role.checked = false;
        });
      });
    }
  },
  computed: {
    groups() {
      return this.$store.state.groups;
    },
    roleCategories() {
      const roleCategories = (this.$store.state.roleCategories || []).map(
        category => ({
          ...category,
          roles: (category.roles || []).map(role => ({ ...role }))
        })
      );

      this.setRolesChecked(roleCategories);
      return roleCategories;
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    }
  }
};
